/* eslint-disable */
import * as Types from '../types.generated';

import { ChildGlossaryTermFragment } from './glossaryNode.generated';
import { GlossaryNodeFragment } from './fragments.generated';
import { gql } from '@apollo/client';
import { ChildGlossaryTermFragmentDoc } from './glossaryNode.generated';
import { GlossaryNodeFragmentDoc } from './fragments.generated';
import * as Apollo from '@apollo/client';
export type GetRootGlossaryTermsQueryVariables = Types.Exact<{ [key: string]: never }>;

export type GetRootGlossaryTermsQuery = { __typename?: 'Query' } & {
    getRootGlossaryTerms?: Types.Maybe<
        { __typename?: 'GetRootGlossaryTermsResult' } & Pick<
            Types.GetRootGlossaryTermsResult,
            'count' | 'start' | 'total'
        > & { terms: Array<{ __typename?: 'GlossaryTerm' } & ChildGlossaryTermFragment> }
    >;
};

export type GetRootGlossaryNodesQueryVariables = Types.Exact<{ [key: string]: never }>;

export type GetRootGlossaryNodesQuery = { __typename?: 'Query' } & {
    getRootGlossaryNodes?: Types.Maybe<
        { __typename?: 'GetRootGlossaryNodesResult' } & Pick<
            Types.GetRootGlossaryNodesResult,
            'count' | 'start' | 'total'
        > & { nodes: Array<{ __typename?: 'GlossaryNode' } & GlossaryNodeFragment> }
    >;
};

export type GetEntityImportValidationMetadataQueryVariables = Types.Exact<{
    input: Types.EntityImportValidationMetadataInput;
}>;

export type GetEntityImportValidationMetadataQuery = { __typename?: 'Query' } & {
    getEntityImportValidationMetadata?: Types.Maybe<
        { __typename?: 'EntityImportValidationMetadataResult' } & {
            validationMetadata: Array<
                { __typename?: 'EntityImportValidationMetadata' } & Pick<
                    Types.EntityImportValidationMetadata,
                    'sheetName' | 'sheetColumns' | 'sampleRows' | 'validate'
                >
            >;
        }
    >;
};

export type ListCustomRelationTypesQueryVariables = Types.Exact<{ [key: string]: never }>;

export type ListCustomRelationTypesQuery = { __typename?: 'Query' } & {
    listCustomRelationTypes: { __typename?: 'ListCustomRelationTypesResult' } & {
        customRelations: Array<
            { __typename?: 'CustomRelation' } & Pick<
                Types.CustomRelation,
                'urn' | 'name' | 'inverseName' | 'sourceEntityType' | 'targetEntityType'
            >
        >;
    };
};

export type UpdateParentNodeMutationVariables = Types.Exact<{
    input: Types.UpdateParentNodeInput;
}>;

export type UpdateParentNodeMutation = { __typename?: 'Mutation' } & Pick<Types.Mutation, 'updateParentNode'>;

export type DeleteGlossaryEntityMutationVariables = Types.Exact<{
    urn: Types.Scalars['String'];
}>;

export type DeleteGlossaryEntityMutation = { __typename?: 'Mutation' } & Pick<Types.Mutation, 'deleteGlossaryEntity'>;

export type UpdateGlossaryPropertyMutationVariables = Types.Exact<{
    input: Types.UpdateGlossaryPropertyInfo;
}>;

export type UpdateGlossaryPropertyMutation = { __typename?: 'Mutation' } & Pick<
    Types.Mutation,
    'updateGlossaryProperty'
>;

export type DeleteGlossaryPropertyMutationVariables = Types.Exact<{
    input: Types.DeleteGlossaryPropertyInfo;
}>;

export type DeleteGlossaryPropertyMutation = { __typename?: 'Mutation' } & Pick<
    Types.Mutation,
    'deleteGlossaryProperty'
>;

export type CreateCustomRelationTypeMutationVariables = Types.Exact<{
    input: Types.CreateCustomRelationTypeInput;
}>;

export type CreateCustomRelationTypeMutation = { __typename?: 'Mutation' } & Pick<
    Types.Mutation,
    'createCustomRelationType'
>;

export type UpdateCustomRelationTypeMutationVariables = Types.Exact<{
    input: Types.UpdateCustomRelationTypeInput;
}>;

export type UpdateCustomRelationTypeMutation = { __typename?: 'Mutation' } & Pick<
    Types.Mutation,
    'updateCustomRelationType'
>;

export type DeleteCustomRelationTypeMutationVariables = Types.Exact<{
    input: Types.DeleteCustomRelationTypeInput;
}>;

export type DeleteCustomRelationTypeMutation = { __typename?: 'Mutation' } & {
    deleteCustomRelationType: { __typename?: 'DeleteCustomRelationTypeResult' } & Pick<
        Types.DeleteCustomRelationTypeResult,
        'success' | 'deletedUrns'
    > & {
            errors: Array<
                { __typename?: 'DeleteCustomRelationTypeError' } & Pick<
                    Types.DeleteCustomRelationTypeError,
                    'urn' | 'message'
                >
            >;
        };
};

export const GetRootGlossaryTermsDocument = gql`
    query getRootGlossaryTerms {
        getRootGlossaryTerms(input: { start: 0, count: 1000 }) {
            count
            start
            total
            terms {
                ...childGlossaryTerm
            }
        }
    }
    ${ChildGlossaryTermFragmentDoc}
`;

/**
 * __useGetRootGlossaryTermsQuery__
 *
 * To run a query within a React component, call `useGetRootGlossaryTermsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetRootGlossaryTermsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetRootGlossaryTermsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetRootGlossaryTermsQuery(
    baseOptions?: Apollo.QueryHookOptions<GetRootGlossaryTermsQuery, GetRootGlossaryTermsQueryVariables>,
) {
    return Apollo.useQuery<GetRootGlossaryTermsQuery, GetRootGlossaryTermsQueryVariables>(
        GetRootGlossaryTermsDocument,
        baseOptions,
    );
}
export function useGetRootGlossaryTermsLazyQuery(
    baseOptions?: Apollo.LazyQueryHookOptions<GetRootGlossaryTermsQuery, GetRootGlossaryTermsQueryVariables>,
) {
    return Apollo.useLazyQuery<GetRootGlossaryTermsQuery, GetRootGlossaryTermsQueryVariables>(
        GetRootGlossaryTermsDocument,
        baseOptions,
    );
}
export type GetRootGlossaryTermsQueryHookResult = ReturnType<typeof useGetRootGlossaryTermsQuery>;
export type GetRootGlossaryTermsLazyQueryHookResult = ReturnType<typeof useGetRootGlossaryTermsLazyQuery>;
export type GetRootGlossaryTermsQueryResult = Apollo.QueryResult<
    GetRootGlossaryTermsQuery,
    GetRootGlossaryTermsQueryVariables
>;
export const GetRootGlossaryNodesDocument = gql`
    query getRootGlossaryNodes {
        getRootGlossaryNodes(input: { start: 0, count: 1000 }) {
            count
            start
            total
            nodes {
                ...glossaryNode
            }
        }
    }
    ${GlossaryNodeFragmentDoc}
`;

/**
 * __useGetRootGlossaryNodesQuery__
 *
 * To run a query within a React component, call `useGetRootGlossaryNodesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetRootGlossaryNodesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetRootGlossaryNodesQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetRootGlossaryNodesQuery(
    baseOptions?: Apollo.QueryHookOptions<GetRootGlossaryNodesQuery, GetRootGlossaryNodesQueryVariables>,
) {
    return Apollo.useQuery<GetRootGlossaryNodesQuery, GetRootGlossaryNodesQueryVariables>(
        GetRootGlossaryNodesDocument,
        baseOptions,
    );
}
export function useGetRootGlossaryNodesLazyQuery(
    baseOptions?: Apollo.LazyQueryHookOptions<GetRootGlossaryNodesQuery, GetRootGlossaryNodesQueryVariables>,
) {
    return Apollo.useLazyQuery<GetRootGlossaryNodesQuery, GetRootGlossaryNodesQueryVariables>(
        GetRootGlossaryNodesDocument,
        baseOptions,
    );
}
export type GetRootGlossaryNodesQueryHookResult = ReturnType<typeof useGetRootGlossaryNodesQuery>;
export type GetRootGlossaryNodesLazyQueryHookResult = ReturnType<typeof useGetRootGlossaryNodesLazyQuery>;
export type GetRootGlossaryNodesQueryResult = Apollo.QueryResult<
    GetRootGlossaryNodesQuery,
    GetRootGlossaryNodesQueryVariables
>;
export const GetEntityImportValidationMetadataDocument = gql`
    query GetEntityImportValidationMetadata($input: EntityImportValidationMetadataInput!) {
        getEntityImportValidationMetadata(input: $input) {
            validationMetadata {
                sheetName
                sheetColumns
                sampleRows
                validate
            }
        }
    }
`;

/**
 * __useGetEntityImportValidationMetadataQuery__
 *
 * To run a query within a React component, call `useGetEntityImportValidationMetadataQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEntityImportValidationMetadataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEntityImportValidationMetadataQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetEntityImportValidationMetadataQuery(
    baseOptions: Apollo.QueryHookOptions<
        GetEntityImportValidationMetadataQuery,
        GetEntityImportValidationMetadataQueryVariables
    >,
) {
    return Apollo.useQuery<GetEntityImportValidationMetadataQuery, GetEntityImportValidationMetadataQueryVariables>(
        GetEntityImportValidationMetadataDocument,
        baseOptions,
    );
}
export function useGetEntityImportValidationMetadataLazyQuery(
    baseOptions?: Apollo.LazyQueryHookOptions<
        GetEntityImportValidationMetadataQuery,
        GetEntityImportValidationMetadataQueryVariables
    >,
) {
    return Apollo.useLazyQuery<GetEntityImportValidationMetadataQuery, GetEntityImportValidationMetadataQueryVariables>(
        GetEntityImportValidationMetadataDocument,
        baseOptions,
    );
}
export type GetEntityImportValidationMetadataQueryHookResult = ReturnType<
    typeof useGetEntityImportValidationMetadataQuery
>;
export type GetEntityImportValidationMetadataLazyQueryHookResult = ReturnType<
    typeof useGetEntityImportValidationMetadataLazyQuery
>;
export type GetEntityImportValidationMetadataQueryResult = Apollo.QueryResult<
    GetEntityImportValidationMetadataQuery,
    GetEntityImportValidationMetadataQueryVariables
>;
export const ListCustomRelationTypesDocument = gql`
    query listCustomRelationTypes {
        listCustomRelationTypes {
            customRelations {
                urn
                name
                inverseName
                sourceEntityType
                targetEntityType
            }
        }
    }
`;

/**
 * __useListCustomRelationTypesQuery__
 *
 * To run a query within a React component, call `useListCustomRelationTypesQuery` and pass it any options that fit your needs.
 * When your component renders, `useListCustomRelationTypesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListCustomRelationTypesQuery({
 *   variables: {
 *   },
 * });
 */
export function useListCustomRelationTypesQuery(
    baseOptions?: Apollo.QueryHookOptions<ListCustomRelationTypesQuery, ListCustomRelationTypesQueryVariables>,
) {
    return Apollo.useQuery<ListCustomRelationTypesQuery, ListCustomRelationTypesQueryVariables>(
        ListCustomRelationTypesDocument,
        baseOptions,
    );
}
export function useListCustomRelationTypesLazyQuery(
    baseOptions?: Apollo.LazyQueryHookOptions<ListCustomRelationTypesQuery, ListCustomRelationTypesQueryVariables>,
) {
    return Apollo.useLazyQuery<ListCustomRelationTypesQuery, ListCustomRelationTypesQueryVariables>(
        ListCustomRelationTypesDocument,
        baseOptions,
    );
}
export type ListCustomRelationTypesQueryHookResult = ReturnType<typeof useListCustomRelationTypesQuery>;
export type ListCustomRelationTypesLazyQueryHookResult = ReturnType<typeof useListCustomRelationTypesLazyQuery>;
export type ListCustomRelationTypesQueryResult = Apollo.QueryResult<
    ListCustomRelationTypesQuery,
    ListCustomRelationTypesQueryVariables
>;
export const UpdateParentNodeDocument = gql`
    mutation updateParentNode($input: UpdateParentNodeInput!) {
        updateParentNode(input: $input)
    }
`;
export type UpdateParentNodeMutationFn = Apollo.MutationFunction<
    UpdateParentNodeMutation,
    UpdateParentNodeMutationVariables
>;

/**
 * __useUpdateParentNodeMutation__
 *
 * To run a mutation, you first call `useUpdateParentNodeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateParentNodeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateParentNodeMutation, { data, loading, error }] = useUpdateParentNodeMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateParentNodeMutation(
    baseOptions?: Apollo.MutationHookOptions<UpdateParentNodeMutation, UpdateParentNodeMutationVariables>,
) {
    return Apollo.useMutation<UpdateParentNodeMutation, UpdateParentNodeMutationVariables>(
        UpdateParentNodeDocument,
        baseOptions,
    );
}
export type UpdateParentNodeMutationHookResult = ReturnType<typeof useUpdateParentNodeMutation>;
export type UpdateParentNodeMutationResult = Apollo.MutationResult<UpdateParentNodeMutation>;
export type UpdateParentNodeMutationOptions = Apollo.BaseMutationOptions<
    UpdateParentNodeMutation,
    UpdateParentNodeMutationVariables
>;
export const DeleteGlossaryEntityDocument = gql`
    mutation deleteGlossaryEntity($urn: String!) {
        deleteGlossaryEntity(urn: $urn)
    }
`;
export type DeleteGlossaryEntityMutationFn = Apollo.MutationFunction<
    DeleteGlossaryEntityMutation,
    DeleteGlossaryEntityMutationVariables
>;

/**
 * __useDeleteGlossaryEntityMutation__
 *
 * To run a mutation, you first call `useDeleteGlossaryEntityMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteGlossaryEntityMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteGlossaryEntityMutation, { data, loading, error }] = useDeleteGlossaryEntityMutation({
 *   variables: {
 *      urn: // value for 'urn'
 *   },
 * });
 */
export function useDeleteGlossaryEntityMutation(
    baseOptions?: Apollo.MutationHookOptions<DeleteGlossaryEntityMutation, DeleteGlossaryEntityMutationVariables>,
) {
    return Apollo.useMutation<DeleteGlossaryEntityMutation, DeleteGlossaryEntityMutationVariables>(
        DeleteGlossaryEntityDocument,
        baseOptions,
    );
}
export type DeleteGlossaryEntityMutationHookResult = ReturnType<typeof useDeleteGlossaryEntityMutation>;
export type DeleteGlossaryEntityMutationResult = Apollo.MutationResult<DeleteGlossaryEntityMutation>;
export type DeleteGlossaryEntityMutationOptions = Apollo.BaseMutationOptions<
    DeleteGlossaryEntityMutation,
    DeleteGlossaryEntityMutationVariables
>;
export const UpdateGlossaryPropertyDocument = gql`
    mutation updateGlossaryProperty($input: UpdateGlossaryPropertyInfo!) {
        updateGlossaryProperty(input: $input)
    }
`;
export type UpdateGlossaryPropertyMutationFn = Apollo.MutationFunction<
    UpdateGlossaryPropertyMutation,
    UpdateGlossaryPropertyMutationVariables
>;

/**
 * __useUpdateGlossaryPropertyMutation__
 *
 * To run a mutation, you first call `useUpdateGlossaryPropertyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateGlossaryPropertyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateGlossaryPropertyMutation, { data, loading, error }] = useUpdateGlossaryPropertyMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateGlossaryPropertyMutation(
    baseOptions?: Apollo.MutationHookOptions<UpdateGlossaryPropertyMutation, UpdateGlossaryPropertyMutationVariables>,
) {
    return Apollo.useMutation<UpdateGlossaryPropertyMutation, UpdateGlossaryPropertyMutationVariables>(
        UpdateGlossaryPropertyDocument,
        baseOptions,
    );
}
export type UpdateGlossaryPropertyMutationHookResult = ReturnType<typeof useUpdateGlossaryPropertyMutation>;
export type UpdateGlossaryPropertyMutationResult = Apollo.MutationResult<UpdateGlossaryPropertyMutation>;
export type UpdateGlossaryPropertyMutationOptions = Apollo.BaseMutationOptions<
    UpdateGlossaryPropertyMutation,
    UpdateGlossaryPropertyMutationVariables
>;
export const DeleteGlossaryPropertyDocument = gql`
    mutation deleteGlossaryProperty($input: DeleteGlossaryPropertyInfo!) {
        deleteGlossaryProperty(input: $input)
    }
`;
export type DeleteGlossaryPropertyMutationFn = Apollo.MutationFunction<
    DeleteGlossaryPropertyMutation,
    DeleteGlossaryPropertyMutationVariables
>;

/**
 * __useDeleteGlossaryPropertyMutation__
 *
 * To run a mutation, you first call `useDeleteGlossaryPropertyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteGlossaryPropertyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteGlossaryPropertyMutation, { data, loading, error }] = useDeleteGlossaryPropertyMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeleteGlossaryPropertyMutation(
    baseOptions?: Apollo.MutationHookOptions<DeleteGlossaryPropertyMutation, DeleteGlossaryPropertyMutationVariables>,
) {
    return Apollo.useMutation<DeleteGlossaryPropertyMutation, DeleteGlossaryPropertyMutationVariables>(
        DeleteGlossaryPropertyDocument,
        baseOptions,
    );
}
export type DeleteGlossaryPropertyMutationHookResult = ReturnType<typeof useDeleteGlossaryPropertyMutation>;
export type DeleteGlossaryPropertyMutationResult = Apollo.MutationResult<DeleteGlossaryPropertyMutation>;
export type DeleteGlossaryPropertyMutationOptions = Apollo.BaseMutationOptions<
    DeleteGlossaryPropertyMutation,
    DeleteGlossaryPropertyMutationVariables
>;
export const CreateCustomRelationTypeDocument = gql`
    mutation createCustomRelationType($input: CreateCustomRelationTypeInput!) {
        createCustomRelationType(input: $input)
    }
`;
export type CreateCustomRelationTypeMutationFn = Apollo.MutationFunction<
    CreateCustomRelationTypeMutation,
    CreateCustomRelationTypeMutationVariables
>;

/**
 * __useCreateCustomRelationTypeMutation__
 *
 * To run a mutation, you first call `useCreateCustomRelationTypeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateCustomRelationTypeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createCustomRelationTypeMutation, { data, loading, error }] = useCreateCustomRelationTypeMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateCustomRelationTypeMutation(
    baseOptions?: Apollo.MutationHookOptions<
        CreateCustomRelationTypeMutation,
        CreateCustomRelationTypeMutationVariables
    >,
) {
    return Apollo.useMutation<CreateCustomRelationTypeMutation, CreateCustomRelationTypeMutationVariables>(
        CreateCustomRelationTypeDocument,
        baseOptions,
    );
}
export type CreateCustomRelationTypeMutationHookResult = ReturnType<typeof useCreateCustomRelationTypeMutation>;
export type CreateCustomRelationTypeMutationResult = Apollo.MutationResult<CreateCustomRelationTypeMutation>;
export type CreateCustomRelationTypeMutationOptions = Apollo.BaseMutationOptions<
    CreateCustomRelationTypeMutation,
    CreateCustomRelationTypeMutationVariables
>;
export const UpdateCustomRelationTypeDocument = gql`
    mutation updateCustomRelationType($input: UpdateCustomRelationTypeInput!) {
        updateCustomRelationType(input: $input)
    }
`;
export type UpdateCustomRelationTypeMutationFn = Apollo.MutationFunction<
    UpdateCustomRelationTypeMutation,
    UpdateCustomRelationTypeMutationVariables
>;

/**
 * __useUpdateCustomRelationTypeMutation__
 *
 * To run a mutation, you first call `useUpdateCustomRelationTypeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCustomRelationTypeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCustomRelationTypeMutation, { data, loading, error }] = useUpdateCustomRelationTypeMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateCustomRelationTypeMutation(
    baseOptions?: Apollo.MutationHookOptions<
        UpdateCustomRelationTypeMutation,
        UpdateCustomRelationTypeMutationVariables
    >,
) {
    return Apollo.useMutation<UpdateCustomRelationTypeMutation, UpdateCustomRelationTypeMutationVariables>(
        UpdateCustomRelationTypeDocument,
        baseOptions,
    );
}
export type UpdateCustomRelationTypeMutationHookResult = ReturnType<typeof useUpdateCustomRelationTypeMutation>;
export type UpdateCustomRelationTypeMutationResult = Apollo.MutationResult<UpdateCustomRelationTypeMutation>;
export type UpdateCustomRelationTypeMutationOptions = Apollo.BaseMutationOptions<
    UpdateCustomRelationTypeMutation,
    UpdateCustomRelationTypeMutationVariables
>;
export const DeleteCustomRelationTypeDocument = gql`
    mutation deleteCustomRelationType($input: DeleteCustomRelationTypeInput!) {
        deleteCustomRelationType(input: $input) {
            success
            deletedUrns
            errors {
                urn
                message
            }
        }
    }
`;
export type DeleteCustomRelationTypeMutationFn = Apollo.MutationFunction<
    DeleteCustomRelationTypeMutation,
    DeleteCustomRelationTypeMutationVariables
>;

/**
 * __useDeleteCustomRelationTypeMutation__
 *
 * To run a mutation, you first call `useDeleteCustomRelationTypeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteCustomRelationTypeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteCustomRelationTypeMutation, { data, loading, error }] = useDeleteCustomRelationTypeMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeleteCustomRelationTypeMutation(
    baseOptions?: Apollo.MutationHookOptions<
        DeleteCustomRelationTypeMutation,
        DeleteCustomRelationTypeMutationVariables
    >,
) {
    return Apollo.useMutation<DeleteCustomRelationTypeMutation, DeleteCustomRelationTypeMutationVariables>(
        DeleteCustomRelationTypeDocument,
        baseOptions,
    );
}
export type DeleteCustomRelationTypeMutationHookResult = ReturnType<typeof useDeleteCustomRelationTypeMutation>;
export type DeleteCustomRelationTypeMutationResult = Apollo.MutationResult<DeleteCustomRelationTypeMutation>;
export type DeleteCustomRelationTypeMutationOptions = Apollo.BaseMutationOptions<
    DeleteCustomRelationTypeMutation,
    DeleteCustomRelationTypeMutationVariables
>;
